export const redirectToLogin = () => {
    window.location.href = "/login";
}
